const base = require('base/paymentInstruments/paymentInstruments');
const installmentHelpers = require('../adyen/checkout/installments');
const { default: getFrontConfig } = require('../common/getFrontConfig');
const type = require('../common/utils/type');

const FRONT_CONFIG = getFrontConfig();

if (typeof base.methods === 'undefined') {
  base.methods = {};
}

/**
 * Remove Payment
 */
function removePayment() {
  $('body').on('click', '.remove-payment', function removePaymentHandler(e) {
    e.preventDefault();

    const url = `${FRONT_CONFIG.urls.deletePayment}?ID=${$(this).data('id')}`;
    $('.remove-payment').trigger('payment:remove', e);
    $.ajax({
      url,
      type: 'get',
      dataType: 'json',
      success() {
        // Reload needed to force adyen to render again the payment from scratch to avoid problems
        window.location.reload();
      },
      error(err) {
        if (err.responseJSON.redirectUrl) {
          window.location.href = err.responseJSON.redirectUrl;
        }
      },
    });
  });
}

/**
 * Card Type Change Event
 */
function cardTypeChangeEvent() {
  const createAdyenPostMessageListenerForAction = (action, callback) => (e) => {
    const isTestMessage = e.data.hello;
    if (!isTestMessage && type.isString(e.data)) {
      const dataJson = JSON.parse(e.data);
      if (dataJson.action === action) {
        callback(dataJson);
      }
    }
  };

  const handleBrandMessage = createAdyenPostMessageListenerForAction(
    'brand',
    (data) => {
      const installmentsContainer = document.getElementById(
        'adyen-new-card-installments'
      );
      const installmentsSelector =
        installmentsContainer.querySelector('select');
      const holderNameInput = document.querySelector(
        '.adyen-checkout__card__holderName'
      );

      const orderTotal = Number.parseFloat(
        document
          .querySelector('.grand-total-container .grand-total')
          .getAttribute('data-value')
      );
      const installmentValues = installmentHelpers.getInstallmentValues(
        data.brand,
        orderTotal
      );

      installmentsSelector.value = '';
      installmentsSelector.innerHTML = '';
      if (installmentValues && installmentValues.length) {
        const installmentOptionEmpty = document.createElement('option');
        installmentOptionEmpty.style = 'display:none';
        installmentOptionEmpty.selected = 'selected';
        installmentOptionEmpty.disabled = true;
        installmentOptionEmpty.value = '';
        installmentOptionEmpty.text = '';
        installmentsSelector.appendChild(installmentOptionEmpty);

        installmentValues.forEach((installmentValue) => {
          const installmentOption = document.createElement('option');
          installmentOption.value = installmentValue;
          if (installmentValue === 1) {
            installmentOption.text = window.installmentsOptionLabelSingular;
          } else {
            installmentOption.text =
              window.installmentsOptionLabelMonthsPlural.replace(
                '{0}',
                installmentValue
              );
          }
          installmentsSelector.append(installmentOption);
        });
        holderNameInput.insertAdjacentElement(
          'afterend',
          installmentsContainer
        );
        installmentsSelector.selectedIndex = 0;
        installmentsContainer.classList.remove('d-none');
      } else {
        installmentsContainer.classList.add('d-none');
      }
    }
  );

  if (window.AdyenInstallmentsEnabled && window.AdyenInstallmentsOptions) {
    // eslint-disable-next-line listeners/no-missing-remove-event-listener
    window.addEventListener('message', handleBrandMessage, false);
  }
}

/**
 * Check if Paypal is selected
 * @returns {boolean} True if Paypal Payment Method is selected
 */
function isPaypalSelected() {
  const paymentInformation = document.querySelector('.payment-information');
  const paypalTab = document.querySelector('.nav-link.paypal-tab');
  return (
    paymentInformation?.dataset.paymentMethodId ===
      FRONT_CONFIG.checkout.paymentMethods.PAYPAL &&
    paypalTab?.classList.contains('active')
  );
}

/**
 * Check if Google Pay is selected
 * @returns {boolean} True if Google Pay Payment Method is selected
 */
function isGooglePaySelected() {
  const paymentInformation = document.querySelector('.payment-information');
  const adyenComponentMethod =
    FRONT_CONFIG.checkout.paymentMethods.AdyenComponent;
  const googlePayMethodPrefix =
    FRONT_CONFIG.checkout.adyenPaymentMethods.GOOGLE_PAY.type;
  const googlePayTab = document.querySelector(
    `.nav-item[data-method-id="${adyenComponentMethod}__${googlePayMethodPrefix}"] .nav-link`
  );
  return (
    paymentInformation?.dataset.paymentMethodId ===
      `${adyenComponentMethod}__${googlePayMethodPrefix}` &&
    googlePayTab?.classList.contains('active')
  );
}

/**
 * Check if Apple Pay is selected
 * @returns {boolean} True if Apple Pay Payment Method is selected
 */
function isApplePaySelected() {
  const paymentInformation = document.querySelector('.payment-information');
  const applepayTab = document.querySelector('.nav-link.applepay-tab');
  return (
    paymentInformation?.dataset.paymentMethodId ===
      FRONT_CONFIG.checkout.paymentMethods.APPLE_PAY &&
    applepayTab?.classList.contains('active')
  );
}

module.exports = Object.assign(base, {
  cardTypeChangeEvent,
  methods: {
    isApplePaySelected,
    isGooglePaySelected,
    isPaypalSelected,
  },
  removePayment,
});
